// client/src/components/watchdog/WatchdogStatsCards.jsx
import React, { useState, useEffect } from "react";

const cardStyles = {
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: "12px",
        marginBottom: "6px",
    },
    card: (accent) => ({
        background: "linear-gradient(135deg, #1a1f2e 0%, #151921 100%)",
        borderRadius: "12px",
        padding: "16px",
        border: `1px solid ${accent}22`,
        borderTop: `3px solid ${accent}`,
    }),
    label: {
        color: "#94a3b8",
        fontSize: "11px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
    },
    value: (accent) => ({
        color: accent,
        fontSize: "28px",
        fontWeight: 800,
        fontVariantNumeric: "tabular-nums",
        marginTop: "4px",
        lineHeight: 1,
    }),
    freshness: {
        textAlign: "right",
        fontSize: "11px",
        color: "#4a5568",
        marginBottom: "12px",
        fontVariantNumeric: "tabular-nums",
    },
};

const cards = [
    { key: "total", label: "Total Watched", accent: "#8b5cf6", icon: "\uD83D\uDC15" },
    { key: "action_pending", label: "Action Pending", accent: "#a855f7", icon: "\u23F3" },
    { key: "settle_ready", label: "Settle Ready", accent: "#f97316", icon: "\uD83C\uDFAF" },
    { key: "mismatches", label: "Mismatches", accent: "#ef4444", icon: "\uD83D\uDEA8" },
    { key: "action_taken", label: "Actions Taken", accent: "#22c55e", icon: "\u26A1" },
    { key: "resolved_by_shiphero", label: "SH Resolved", accent: "#06b6d4", icon: "\uD83D\uDD04" },
    { key: "validated_ok", label: "Validated OK", accent: "#10b981", icon: "\u2705" },
    { key: "fulfilled", label: "Fulfilled", accent: "#6366f1", icon: "\uD83D\uDCE6" },
    { key: "action_failed", label: "Failed", accent: "#94a3b8", icon: "\u274C" },
];

function useRelativeTime(isoString) {
    const [text, setText] = useState("");

    useEffect(() => {
        if (!isoString) return;
        const update = () => {
            const diff = Math.floor((Date.now() - new Date(isoString).getTime()) / 1000);
            if (diff < 5) setText("Updated just now");
            else if (diff < 60) setText(`Updated ${diff}s ago`);
            else setText(`Updated ${Math.floor(diff / 60)}m ago`);
        };
        update();
        const id = setInterval(update, 1000);
        return () => clearInterval(id);
    }, [isoString]);

    return text;
}

export default function WatchdogStatsCards({ stats, lastUpdated }) {
    const freshness = useRelativeTime(lastUpdated);

    if (!stats) return null;

    return (
        <>
            {lastUpdated && <div style={cardStyles.freshness}>{freshness}</div>}
            <div style={cardStyles.grid}>
                {cards.map(c => (
                    <div key={c.key} style={cardStyles.card(c.accent)}>
                        <div style={cardStyles.label}>
                            {c.icon} {c.label}
                        </div>
                        <div style={cardStyles.value(c.accent)}>
                            {stats[c.key] ?? 0}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}
